<template>
  <div>
    <div class="tab-wrap">
      <span :class="{ tab: true, active: status == 1 }" @click="selTab(1)">人员变更记录</span>
      <span :class="{ tab: true, active: status == 2 }" @click="selTab(2)">职级变更记录</span>
    </div>
    <div v-show="status == 1" class="salesman-form-record">
      <Timeline>
        <TimelineItem v-for="(item, i) in list" :key="i">
          <div class="dian" :class="{ 'active': i == 0 }" slot="dot"></div>
          <div class="row">
            <span class="text1">更改字段</span>
            <span class="text2">“{{ item.propertyname }}”，
              <span v-if="item.eyeShow1">【{{ item.oldvalueShow }}】</span>
              <span v-else>【{{ item.oldvalue }}】</span>
              <template v-if="item.property == 'mobile' || item.property == 'idNo' || (item.property == 'cardNo' && item.oldvalue) || (item.property == 'address' && item.oldvalue) || (item.property == 'email' && item.oldvalue)|| (item.property == 'userContactsMobileOne' && item.oldvalue)|| (item.property == 'userContactsMobileTwo' && item.oldvalue)">
                <i class="iconfont iconxianshi eye-icon" v-if="item.eyeShow1" @click="openEye(item, 'eyeShow1')"></i>
                <i class="iconfont iconyincang eye-icon" v-else @click="openEye(item, 'eyeShow1')"></i>
              </template>
              →
              <span v-if="item.eyeShow2">【{{ item.newvalueShow }}】</span>
              <span v-else class="new-value">【{{ item.newvalue }}】</span>
              <template v-if="item.property == 'mobile' || item.property == 'idNo' || (item.property == 'cardNo' && item.newvalue) || (item.property == 'address' && item.newvalue) || (item.property == 'email' && item.newvalue)|| (item.property == 'userContactsMobileOne' && item.oldvalue)|| (item.property == 'userContactsMobileTwo' && item.oldvalue)">
                <i class="iconfont iconxianshi eye-icon" v-if="item.eyeShow2" @click="openEye(item, 'eyeShow2')"></i>
                <i class="iconfont iconyincang eye-icon" v-else @click="openEye(item, 'eyeShow2')"></i>
              </template>
            </span>
            <span class="by">操作人：{{ item.createName }}</span>
          </div>
          <p class="time">操作日期：{{ item.createTime | cutString(16) }}</p>
          <p v-if="item.effectiveDate" class="time">生效日期：{{ item.effectiveDate | cutString(16) }}</p>
        </TimelineItem>
      </Timeline>
      <no-data v-if="list.length == 0 && !loading"></no-data>
    </div>
    <div v-show="status == 2">
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="attachments">
            <a v-if="row.attachments" :href="row.attachments[0].path" target="_blank">
              {{ row.attachments[0].fileName}}</a>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
            style="text-align: center" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from "@/api/filter";
import { common, pageTool } from "@/api/mixins";
export default {
  mixins: [common, pageTool],
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      list: [],
      status: '1',
      columns: [
        {
          title: "变更前组织",
          key: "oldOrganizationName",
          align: "center",
          minWidth: 160,
          render(h, params) {
            const text = `${params.row.oldOrganizationName || '-'}/${params.row.oldGroupName || '-'}`;
            return <span>{text}</span>;
          },
        },
        {
          title: "变更后组织",
          key: "newOrganizationName",
          align: "center",
          minWidth: 160,
          render(h, params) {
            const text = `${params.row.newOrganizationName || '-'}/${params.row.newGroupName || '-'}`;
            return <span>{text}</span>;
          },
        },
        {
          title: "原职级/新职级",
          key: "oldRankName",
          align: "center",
          minWidth: 160,
          render(h, params) {
            const text = `${params.row.oldRankName || '-'}/${params.row.newRankName || '-'}`;
            return <span>{text}</span>;
          },
        },
        {
          title: "生效日期",
          key: "effectiveDate",
          align: "center",
          width: 140,
          render(h, params) {
            const value = filters.filterTime(params.row.effectiveDate, 'YYYY-MM-DD HH:mm')
            return <span>{value}</span>
          },
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          minWidth: 200,
          render(h, params) {
            let text = params.row.remark;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text
                ),
                h('span', { slot: 'content' }, text)
              ]
            );
          }
        },
        {
          title: "附件",
          slot: "attachments",
          align: "center",
          minWidth: 120,
        },
        {
          title: "操作日期",
          key: "createTime",
          align: "center",
          minWidth: 140,
          render(h, params) {
            const value = filters.filterTime(params.row.createTime, 'YYYY-MM-DD HH:mm')
            return <span>{value}</span>
          },
        },
        {
          title: "操作人",
          key: "operateName",
          align: "center",
          minWidth: 120,
        },
      ],
    };
  },
  watch: {},
  computed: {},
  created() { },
  mounted() {
    this.userId = this.$route.query.userId;
    this.searchParams.userId = this.$route.query.userId;
  },
  methods: {
    listCallback(res) {
      this.tableData = res.data.map(item => {
        console.log(item)
        if (item.attachments) {
          item.attachments = JSON.parse(item.attachments)
        }
        console.log(item)
        return item
      })
    },
    selTab(val) {
      this.status = val;
      if (val == 1) {
        this.setData()
      } else {
        this.initListAjax("/buz/userRankChangeRecord/read/list");
      }
    },
    // 转化参数
    setListParams(params) {
      params.status = 1;
    },
    setData() {
      this.loading = true;
      this.$http({
        url: '/buz/userChangeRecord/read/list',
        type: 'post',
        data: {
          userId: this.userId,
          pageNo: 1,
          pageSize: 999
        },
      }).then((res) => {
        this.loading = false;
        this.list = res.data;
      }).catch((e) => {
        this.loading = false;
      })
    },
    // 解密
    openEye(item, eyeKey) {
      let type = "";
      if (item.property == "mobile") {
        type = '2';
      } else if (item.property == "idNo") {
        type = '1';
      } else if (item.property == "cardNo") {
        type = '3';
      } else if (item.property == "email") {
        type = '4';
      } else if (item.property == "address") {
        type = '5';
      }  else if (item.property == "userContactsMobileOne" || item.property == "userContactsMobileTwo") {
        type = '6';
      } else {
        return;
      }
      if (!item[eyeKey]) {
        this.descrypt({
          query: item.id,
          operationFunction: eyeKey == 'eyeShow1' ? '4' : '5',
          operationType: type,
        }, item, eyeKey == 'eyeShow1' ? 'oldvalueShow' : 'newvalueShow').then(() => {
          this.$set(item, eyeKey, true);
        })
      } else {
        this.$set(item, eyeKey, false);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.tab-wrap {
  margin-bottom: 15px;

  .tab {
    cursor: pointer;
    margin-left: 20px;
    display: inline-block;
    text-align: center;
    padding: 6px 0 6px;
    color: #727c8e;

    &:first-child {
      margin-left: 0;
    }
  }

  .active {
    color: #236DFF;
    border-bottom: 2px solid #236DFF;
  }
}


.salesman-form-record {
  min-height: calc(100vh - 80px);

  /deep/ {
    .ivu-timeline-item-content {
      top: -5px;
    }

    .ivu-timeline-item-head {
      background: transparent;
    }

    .ivu-timeline-item-tail {
      border-left: 1px dashed #eee;
      top: 8px;
    }
  }

  .dian {
    width: 11px;
    height: 11px;
    background-color: #F7F7F7;
    margin: auto;
    border-radius: 50%;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #E8F0FF;

    &::before {
      content: "";
      display: block;
      width: 7px;
      height: 7px;
      background: #D4D5D8;
      border-radius: 50%;
    }

    &.active::before {
      background: #236DFF;
    }
  }

  .row {
    font-size: 12px;
    width: 710px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .text1 {
      color: #727C8E;
    }

    .text2 {
      color: #515C6F;
      display: flex;
      align-items: center;
      .new-value {
        word-break:break-all;
      }
    }

    .by {
      margin-left: auto;
      color: #A8ADB7;
    }
  }

  .time {
    color: #515C6F;
    font-size: 12px;
    padding-bottom: 10px;
  }
}
</style>